import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if a password is at least 8 characters long,
 * and contains at least one letter, one digit, and one special character.
 */
export function strongPasswordValidator(): ValidatorFn {
  // Minimum 8 characters, at least one letter, one digit, and one special character
  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) return null; // Let required validator handle empty

    if (!regex.test(value)) {
      return {
        strongPassword: {
          valid: false,
          message: 'Password must be at least 8 characters long and include a letter, a number, and a special character.',
        },
      };
    }

    return null;
  };
}

export function passwordsMatchValidator(newPasswordKey: string, confirmPasswordKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(newPasswordKey)?.value;
    const confirmPassword = group.get(confirmPasswordKey)?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  };
}
